<script setup lang="ts">
import type { Article } from '~/types/article'

defineProps<Pick<Article, 'title' | 'slug' | 'excerpt' | 'thumbnail_url' | 'tags' | 'published_at'>>()
</script>

<template>
  <NuxtLink
    :to="`/blog/${slug}`"
    class="group block"
  >
    <div class="rounded-xl border border-default bg-elevated overflow-hidden transition-all duration-200 hover:border-zinc-600 hover:shadow-lg h-full flex flex-col">
      <!-- Thumbnail -->
      <div class="aspect-video bg-gradient-to-br from-zinc-800 to-zinc-900 overflow-hidden">
        <NuxtImg
          v-if="thumbnail_url"
          :src="thumbnail_url"
          :alt="title"
          class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div
          v-else
          class="w-full h-full flex items-center justify-center"
        >
          <UIcon
            name="i-lucide-file-text"
            class="size-10 text-muted opacity-30"
          />
        </div>
      </div>

      <!-- Content -->
      <div class="flex flex-col flex-1 p-5">
        <div class="flex flex-wrap gap-1.5 mb-3">
          <UBadge
            v-for="tag in tags.slice(0, 3)"
            :key="tag"
            variant="subtle"
            size="sm"
            class="text-zinc-700 dark:text-zinc-200"
          >
            {{ tag }}
          </UBadge>
        </div>

        <h3 class="font-semibold text-highlighted text-base leading-snug mb-2 line-clamp-2">
          {{ title }}
        </h3>

        <p
          v-if="excerpt"
          class="text-sm text-muted leading-relaxed line-clamp-3 flex-1 mb-3"
        >
          {{ excerpt }}
        </p>

        <p class="text-sm text-muted mt-auto">
          {{ published_at ? formatDateShort(published_at) : '' }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>
